import {ChangeDetectorRef, Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SearchOptions} from "../../../../models/Search/SearchOptions";
import {SearchFilter} from "../../../../models/Search/SearchFilter";
import {BehaviorSubject, Subscription} from "rxjs";
import {debounceTime, skip} from "rxjs/operators";

@Component({
  selector: 'app-search-filters',
  templateUrl: './search-filters.component.html',
  styleUrls: ['./search-filters.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchFiltersComponent),
      multi: true
    }
  ]
})
export class SearchFiltersComponent implements OnInit, ControlValueAccessor, OnDestroy {

  @Input() dateLabel: string = 'Date Range';
  @Input() type: "donations" | "generic" = "donations";
  updateModel: any;
  value: SearchOptions
  termSubscription: Subscription;
  term: BehaviorSubject<string> = new BehaviorSubject<string>('');

  dateRange: Date[];
  showDatePopup:boolean = false;
  date_field = 'created_at';
  today = new Date();

  constructor(private ref:ChangeDetectorRef) { }

  ngOnInit(): void {
    this.termSubscription = this.term.pipe(skip(1), debounceTime(500)).subscribe((data)=>{
        this.value.term = data;
        if(!data){
          this.value.term = undefined;
        }
        this.updateModel(this.value);
    })
  }

  ngOnDestroy() {
    this.termSubscription.unsubscribe();
  }

  registerOnChange(fn: any): void {
    this.updateModel = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: SearchOptions): void {
    if(obj) {
      this.value = obj;
    }else{
      this.value = new SearchOptions();
    }

    this.setDates();
  }

  getDateValue(): any{
    const startDate = this.findField(this.date_field, '<=')?.value;
    const endDate = this.findField(this.date_field, '>=')?.value;

    if(startDate && endDate){
      return [
        new Date(startDate),
        new Date(endDate)
      ]
    }else{
      return []
    }

  }

  findField(field: string, operator: string): SearchFilter | undefined{
      if(this.value.filters){
        for(const value of this.value.filters){
          if(value.field === field && value.operator === operator){
            return value;
          }
        }
      }

      return undefined;
  }


  setDates(): void{
    this.dateRange = this.getDateValue();
  }

  updateDate(data:any): void{
    this.dateRange = data;
  }

  resetDate(): void{
    this.dateRange = [];
    let beforeIndex: number | undefined = -1;
    let afterIndex: number | undefined = -1;
    beforeIndex = this.value.filters?.findIndex((item) =>
      item.field === this.date_field && item.operator === '>='
    );
    afterIndex = this.value.filters?.findIndex((item) =>
      item.field === this.date_field && item.operator === '<='
    );
    if(beforeIndex && beforeIndex > -1) {
      this.value.filters?.splice(beforeIndex, 1);
    }
    if(afterIndex && afterIndex > -1) {
      this.value.filters?.splice(afterIndex, 1);
    }
    this.updateModel(this.value);

  }

  applyDate(): void{

    if(!this.dateRange[0]){
      this.showDatePopup = false;
      return;
    }

    let beforeIndex: number | undefined = -1;
    let afterIndex: number | undefined = -1;

    beforeIndex = this.value.filters?.findIndex((item) =>
       item.field === this.date_field && item.operator === '>='
    );
    afterIndex = this.value.filters?.findIndex((item) =>
      item.field === this.date_field && item.operator === '<='
    );

    if(beforeIndex && beforeIndex > -1){
      // @ts-ignore
      this.value.filters[beforeIndex].value = this.dateRange[0].toISOString();
    }else{
      this.value.filters?.push({
        field: this.date_field,
        operator: '>=',
        value: this.dateRange[0].toISOString()
      })
    }

    if(afterIndex && afterIndex > -1){
      // @ts-ignore
      this.value.filters[afterIndex].value = this.dateRange[1].toISOString();
    }else{
      this.value.filters?.push({
        field: this.date_field,
        operator: '<=',
        value: this.dateRange[1].toISOString()
      })
    }

    this.updateModel(this.value);

  }

  updateField(field: string, operator:string, value:string) {
    const index = this.value.filters?.findIndex((item) =>
      item.field === field && item.operator === operator
    );

    if (this.value.filters) {
      if (index && index > -1) {
        if(value){
          this.value.filters[index].value = value;
        }else{
          this.value.filters.splice(index,1);
        }
      }else{
        if(value){
          this.value.filters.push({
            field:field,
            operator:operator,
            value:value
          });
        }
      }
    }

    this.updateModel(this.value);

  }



  datePopupStateChange(data:any): void{
    if(!data){
      this.applyDate();
    }
  }

}
